exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-grid-column[data-v-33c656b7] {\n  display: none;\n}\n", ""]);

// exports
